// RTK have it's own actions. These action creaters are specifically for sagas
import { createAction } from '@reduxjs/toolkit';
export const getDocuments = createAction('documents/saga/get-documents');
